import LazyLoad from 'vanilla-lazyload';

const isMobile = window.isMobileDetected;
// Lazyloading
let lazyLoad = new LazyLoad({
    elements_selector: '.lazyload',
    class_loaded: 'lazyloaded',
    threshold: 100,
    use_native: true,
    unobserve_entered: true,
    callback_error: (el) => {
        console.error('Lazyloading: Element image could not be lazy loaded.', el);
    }
});

// Instance without native lazy loading for lazy loading background images
const lazyLoadBackground = new LazyLoad({
    // DON'T PASS use_native: true HERE!
    // It doesn't work with background images!
    elements_selector: '.lazyload-background',
    class_loaded: 'lazyloaded',
    threshold: 50,
    unobserve_entered: true,
    callback_error: (el) => {
        console.error('Lazyloading: Element image could not be lazy loaded.', el);
    }
});

let container = document.querySelector('.wt-Map_ContentLayer, .tab-content-box');

if (container) {
    var lazyLoadMapLayer = new LazyLoad({
        elements_selector: '.lazyload',
        class_loaded: 'lazyloaded',
        container: container
    });
}

// Dependecies
window.c24_lazyloadLibs = {
    LazyLoadClass: LazyLoad,
    lazyLoad: lazyLoad,
    lazyLoadBackground: lazyLoadBackground,
    lazyLoadMapLayer: lazyLoadMapLayer
};

// hoverTrigger = Gratbar-Icon
document.querySelectorAll('.tcms-js-hover').forEach((gratbarItem) => {
    window.fireOnVisible(gratbarItem, async(elem) => {
        const hoverTrigger = elem.querySelector('.additionalInfo');

        if (hoverTrigger) {
            if (isMobile) {
                hoverTrigger.addEventListener('click', () => {
                    elem.classList.toggle('hover');
                });
            } else {
                hoverTrigger.addEventListener('mouseenter', () => {
                    elem.classList.add('hover');
                });

                hoverTrigger.addEventListener('mouseleave', () => {
                    elem.classList.remove('hover');
                });
            }
        }
    });
});

let gratbarElements = document.querySelectorAll('.gratbar');

if (isMobile && gratbarElements.length > 0) {
    gratbarElements.forEach((gratbar) => {
        // gratbar tooltip close button (mobile)
        let closeButton = gratbar.querySelector('.closeBtn');
        let hoveringElem = gratbar.querySelector('.tcms-js-hover');

        if (closeButton && hoveringElem) {
            closeButton.addEventListener('click', (e) => {
                e.stopPropagation();
                hoveringElem.classList.remove('hover');
            });
        }
    });
}
